// extracted by mini-css-extract-plugin
export default {"not-found-page":"NotFound-module__not-found-page__LwTO6","notFoundPage":"NotFound-module__not-found-page__LwTO6","button":"NotFound-module__button__iUcUi"};